import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessIxVblKgvBuExportStatus: 'idle',
    startProcessIxVblKgvBuExportError: undefined as any,
    loadUserParamsProcessIxVblKgvBuExportStatus: 'idle',
    loadUserParamsProcessIxVblKgvBuExportError: undefined as any,

    processIxVblKgvBuExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessIxVblKgvBuExport = createAsyncThunk('processIxVblKgvBuExportSlice/startProcessIxVblKgvBuExport', async ({ processIxVblKgvBuExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessIxVblKgvBuExport/`,
        prepareData(processIxVblKgvBuExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessIxVblKgvBuExportStatus } = getState().processIxVblKgvBuExportSlice
        return startProcessIxVblKgvBuExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessIxVblKgvBuExport = createAsyncThunk('processIxVblKgvBuExportSlice/loadUserParamsProcessIxVblKgvBuExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessIxVblKgvBuExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessIxVblKgvBuExportStatus } = getState().processIxVblKgvBuExportSlice
        return loadUserParamsProcessIxVblKgvBuExportStatus !== 'pending'
    }
})

const ProcessIxVblKgvBuExportSlice = createSlice({
    name: 'processIxVblKgvBuExportSlice',
    initialState,
    reducers: {
        resetstartProcessIxVblKgvBuExport: (state) => {
            state.job = undefined
            state.startProcessIxVblKgvBuExportError = undefined
        },
        resetstartProcessIxVblKgvBuExportError: (state) => {
            state.startProcessIxVblKgvBuExportError = undefined
        },
        resetloadUserParamsProcessIxVblKgvBuExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessIxVblKgvBuExportError = undefined
        },
        resetloadUserParamsProcessIxVblKgvBuExportError: (state) => {
            state.loadUserParamsProcessIxVblKgvBuExportError = undefined
        },
        removeFromProcessIxVblKgvBuExportListById: (state, action) => {
            state.processIxVblKgvBuExportList = state.processIxVblKgvBuExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessIxVblKgvBuExportListByIds: (state, action) => {
            state.processIxVblKgvBuExportList = state.processIxVblKgvBuExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processIxVblKgvBuExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessIxVblKgvBuExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processIxVblKgvBuExportList = []
            state.startProcessIxVblKgvBuExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessIxVblKgvBuExport.pending, (state) => {
            state.startProcessIxVblKgvBuExportStatus = 'pending'
            state.startProcessIxVblKgvBuExportError = undefined
        })
        builder.addCase(startProcessIxVblKgvBuExport.fulfilled, (state, action) => {
            state.startProcessIxVblKgvBuExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessIxVblKgvBuExport.rejected, (state, action) => {
            state.startProcessIxVblKgvBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessIxVblKgvBuExportError = action.error.message
            } else {
                state.startProcessIxVblKgvBuExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessIxVblKgvBuExport.pending, (state) => {
            state.loadUserParamsProcessIxVblKgvBuExportStatus = 'pending'
            state.loadUserParamsProcessIxVblKgvBuExportError = undefined
        })
        builder.addCase(loadUserParamsProcessIxVblKgvBuExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessIxVblKgvBuExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessIxVblKgvBuExport.rejected, (state, action) => {
            state.loadUserParamsProcessIxVblKgvBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessIxVblKgvBuExportError = action.error.message
            } else {
                state.loadUserParamsProcessIxVblKgvBuExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessIxVblKgvBuExport,
    resetstartProcessIxVblKgvBuExportError,
    resetloadUserParamsProcessIxVblKgvBuExport,
    resetloadUserParamsProcessIxVblKgvBuExportError,
    removeFromProcessIxVblKgvBuExportListById,
    removeFromProcessIxVblKgvBuExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessIxVblKgvBuExportSlice.actions
export default ProcessIxVblKgvBuExportSlice.reducer
